<template>
  <div class="withdrawal_record" style="padding-bottom: 2rem">
    <navbar>
      <template #left>
        <!-- <span class="material-icons">chevron_left</span> -->
        <svg t="1748487155504" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
          p-id="21829" width=".6rem" height=".6rem">
          <path
            d="M637.5424 231.2192c22.8352 22.3232 24.6272 53.4016 0 80.6912l-191.8464 200.0896 191.8464 200.0896c24.6272 27.2896 22.8352 58.4192 0 80.5888-22.784 22.3232-61.2864 20.8896-82.688 0-21.4016-20.7872-230.5024-240.384-230.5024-240.384-11.4176-11.1104-17.152-25.7024-17.152-40.2944s5.7344-29.184 17.152-40.3968c0 0 209.1008-219.4944 230.5024-240.384s59.904-22.3232 82.688 0z"
            fill="#ffffff" p-id="21830"></path>
        </svg>
      </template>
      <template #title>
        <span style="color: #fff;font-size: .4267rem;">
          {{ $t('user.t25') }}
        </span>
      </template>
    </navbar>
    <div class="p">
      <div class="list">
        <div class="item" v-for="item in list" :key="item.id">
          <div class="t">
            <div class="avatar">
              <span class="material-icons">notifications</span>
            </div>
            <div class="txt">
              {{ item.title }}
            </div>
          </div>
          <div style="height: 1px;background-color: #36165d;margin: .4267rem 0;"></div>
          <div class="b" v-html="item.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
    }
  },
  created() {
    this.getSystemMessages()
  },
  methods: {
    getSystemMessages() {
      this.$http.getSystemMessages().then(res => {
        if (res.code === 0) {
          this.list = res.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.withdrawal_record {
  .material-icons {}

  span {}

  .p {
    padding: 0 .4rem;

    .list {
      padding: .4rem 0;

      .item {
        padding: .4267rem;
        margin-bottom: .64rem;
        display: flex;
        background-color: black;
        border-radius: .4267rem;
        flex-direction: column;

        .t {
          display: flex;
          align-items: center;

          .avatar {
            margin: 0 .4rem;
            margin-left: 0;
            color: #fff;
            opacity: .7;
            background: linear-gradient(135deg, #DD585CFF 0%, #D44246 100%);
            border-radius: .2667rem;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 1.0667rem;
            height: 1.0667rem;

            .material-icons {}
          }

          .txt {
            color: #fff;
          }
        }

        .b {
          color: #666;
        }
      }
    }
  }
}
</style>
